module.exports = __webpack_public_path__ + "static/media/15.bc1b9b65.jpg";